import { ChangeDetectionStrategy, Component, HostBinding, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RightPanelService } from '../../services/right-panel.service';
import { RightPanelContent } from '../right-panel/right-panel.component';

@UntilDestroy()
@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnInit {
    @HostBinding('class.collapsed-sidebar')
    public collapsedSidebar = false;

    private readonly rightPanelService = inject(RightPanelService);
    private readonly cdr = inject(ChangeDetectorRef);

    public rightPanelVisible = false;
    public rightPanelExpanded = false;
    public rightPanelCollapsed = false;
    public rightPanelContent: RightPanelContent | null = null;

    public ngOnInit() {
        // Subscribe to right panel state changes
        this.rightPanelService.isVisible$.pipe(untilDestroyed(this)).subscribe((visible) => {
            this.rightPanelVisible = visible;
            this.cdr.markForCheck();
        });

        this.rightPanelService.isExpanded$.pipe(untilDestroyed(this)).subscribe((expanded) => {
            this.rightPanelExpanded = expanded;
            this.cdr.markForCheck();
        });

        this.rightPanelService.isCollapsed$.pipe(untilDestroyed(this)).subscribe((collapsed) => {
            this.rightPanelCollapsed = collapsed;
            this.cdr.markForCheck();
        });

        this.rightPanelService.content$.pipe(untilDestroyed(this)).subscribe((content) => {
            this.rightPanelContent = content;
            this.cdr.markForCheck();
        });
    }

    public onRightPanelVisibilityChange(visible: boolean) {
        if (!visible) {
            this.rightPanelService.hide();
        }
    }

    public onRightPanelExpandedChange(expanded: boolean) {
        this.rightPanelService.setExpanded(expanded);
    }

    public onRightPanelCollapsedChange(collapsed: boolean) {
        this.rightPanelService.setCollapsed(collapsed);
    }
}
